export enum MaterialAppearance {
  FILL = 'fill',
  STANDARD = 'standard',
  LEGACY = 'legacy',
  OUTLINE = 'outline'
}
